var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63206 11.6089C2.03789 10.6186 2.03789 9.38143 2.63206 8.39114V8.39114C2.81338 8.08895 3.11376 7.87726 3.45933 7.80815L4.87019 7.52598C4.95424 7.50917 5.03001 7.46409 5.08488 7.39824L6.3376 5.89498C7.52015 4.47592 8.11143 3.76638 8.63909 3.95742C9.16675 4.14846 9.16675 5.07207 9.16675 6.91928L9.16675 13.0807C9.16675 14.9279 9.16675 15.8515 8.63909 16.0426C8.11143 16.2336 7.52015 15.5241 6.3376 14.105L5.08488 12.6018C5.03001 12.5359 4.95424 12.4908 4.87019 12.474L3.45933 12.1918C3.11376 12.1227 2.81338 11.9111 2.63206 11.6089V11.6089Z",
    stroke: "#0573E4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9462 7.05373C13.7236 7.83111 14.1622 8.88422 14.1666 9.9836C14.1709 11.083 13.7406 12.1395 12.9693 12.923",
    stroke: "#0573E4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3807 5.28596C17.6245 6.52977 18.3264 8.21475 18.3333 9.97375C18.3402 11.7327 17.6517 13.4232 16.4177 14.6768",
    stroke: "#0573E4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOn);
export default __webpack_public_path__ + "static/media/volumeOn.6cf01f016d960b4049e59813244ff67d.svg";
export { ForwardRef as ReactComponent };